import { createFileRoute, Outlet } from '@tanstack/react-router'
import { KeyGate } from '@/crypto/KeyGate'
import { PaginasDaSessao } from '@/features/sessao/PaginasDaSessao'
import { useSessionCrumbs } from '@/nav'

/**
 * As páginas de uma sessão: preparação, nota e análise, sob um cabeçalho só.
 *
 * O sublinhado em `$id_` tira estas rotas de dentro do console: `/app/s/:id`
 * é uma tela cheia que não tem `Outlet`. `_sessao` é a camada sem caminho que
 * dá às três o mesmo cabeçalho. A chave fica aqui porque tudo nelas é
 * conteúdo clínico.
 */
export const Route = createFileRoute('/_app/app/s/$id_/_sessao')({
  staticData: { crumb: { useCrumbs: useSessionCrumbs } },
  component: function Sessao() {
    const { id } = Route.useParams()
    return (
      <KeyGate>
        <PaginasDaSessao key={id} sessionId={id}>
          <Outlet />
        </PaginasDaSessao>
      </KeyGate>
    )
  },
})
